import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { GuardUtilsService } from '../services/guard-utils.service';
import { UserService } from '../services/user.service';
import { getUserHomePage } from '../utils';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard {
  private userService = inject(UserService);
  private guardUtilsService = inject(GuardUtilsService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const permissions = route.data.permissions || ([] as string[]);
    const hasAccess = this.userService.hasPermissions(permissions);

    if (hasAccess) {
      return true;
    }

    if (!hasAccess && state.url === '/dashboard') {
      const homePage = getUserHomePage(this.userService.getUser());
      this.router.navigate([homePage]);
      return false;
    }

    this.guardUtilsService.handleNoAccess(
      'Permission denied',
      'Your company does not have access to this module. Contact your administrator to get access.',
    );
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }
}
